<div id="turnstile-container" class="turnstile-container" data-test="turnstile-container"></div>
<input type="hidden" name="cf-turnstile-response" [value]="token || ''" data-test="turnstile-token" />
